/** Typed wrappers for /v2/console/auth/* endpoints. */
import { apiPost } from './client';

export interface UserSummary {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  is_active: boolean;
  is_staff: boolean;
  /** Login / me / MFA responses: the console offers the tenant release-gate override only to a
   *  superuser (the API checks it again). */
  is_superuser?: boolean;
  last_login: string | null;
  date_joined: string;
}

export interface LoginResponse200 {
  token: string;
  token_expires: string;
  user: UserSummary;
  must_enroll_mfa?: boolean;
}

export interface LoginResponse202 {
  mfa_pending_token: string;
  methods: Array<'totp' | 'sms' | 'email'>;
  default_method: 'totp' | 'sms' | 'email';
  expires_in: number;
}

export type LoginResponse = LoginResponse200 | LoginResponse202;

export function isMfaPending(r: LoginResponse): r is LoginResponse202 {
  return 'mfa_pending_token' in r;
}

export async function login(email: string, password: string): Promise<LoginResponse> {
  // Both 200 and 202 land here — axios doesn't reject on 2xx.
  return apiPost<LoginResponse>('/auth/login/', { email, password });
}

export async function logout(): Promise<void> {
  await apiPost<void>('/auth/logout/');
}

export async function rotateToken(): Promise<{ token: string; token_expires: string }> {
  return apiPost('/auth/token/rotate/');
}
